"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentCollectionsPatchSchema = void 0;
exports.ContentCollectionsPatchSchema = {
    "$id": "https://www.redbull.com/schemas/patch/contentCollections.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ContentCollectionsPatch",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "id": {
            "type": "string",
            "pattern": "rrn:content:[A-Za-z-]*:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}"
        },
        "type": {
            "type": "string",
            "pattern": "rrn:patch:contentCollections"
        },
        "relationships": {
            "type": "object",
            "properties": {
                "contentCollections": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": [
                                "array",
                                "object"
                            ],
                            "items": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "additionalProperties": false,
                                        "properties": {
                                            "id": {
                                                "type": "string",
                                                "pattern": "rrn:content:collections:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}"
                                            },
                                            "type": {
                                                "type": "string",
                                                "enum": [
                                                    "rrn:content:collections"
                                                ]
                                            }
                                        },
                                        "required": [
                                            "id",
                                            "type"
                                        ]
                                    }
                                ]
                            },
                            "minItems": 1,
                            "required": [
                                "id",
                                "type"
                            ]
                        }
                    },
                    "required": [
                        "data"
                    ]
                }
            },
            "required": [
                "contentCollections"
            ]
        }
    },
    "required": [
        "id",
        "relationships",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGVudENvbGxlY3Rpb25zLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2R1bGVzL3BhdGNoL2NvbnRlbnRDb2xsZWN0aW9ucy5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSw2QkFBNkIsR0FBRztJQUMzQyxLQUFLLEVBQUUsc0VBQXNFO0lBQzdFLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLHlCQUF5QjtJQUNsQyxNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLElBQUksRUFBRTtZQUNKLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFNBQVMsRUFBRSw0RkFBNEY7U0FDeEc7UUFDRCxNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixTQUFTLEVBQUUsOEJBQThCO1NBQzFDO1FBQ0QsZUFBZSxFQUFFO1lBQ2YsTUFBTSxFQUFFLFFBQVE7WUFDaEIsWUFBWSxFQUFFO2dCQUNaLG9CQUFvQixFQUFFO29CQUNwQixNQUFNLEVBQUUsUUFBUTtvQkFDaEIsWUFBWSxFQUFFO3dCQUNaLE1BQU0sRUFBRTs0QkFDTixNQUFNLEVBQUU7Z0NBQ04sT0FBTztnQ0FDUCxRQUFROzZCQUNUOzRCQUNELE9BQU8sRUFBRTtnQ0FDUCxPQUFPLEVBQUU7b0NBQ1A7d0NBQ0UsTUFBTSxFQUFFLFFBQVE7d0NBQ2hCLHNCQUFzQixFQUFFLEtBQUs7d0NBQzdCLFlBQVksRUFBRTs0Q0FDWixJQUFJLEVBQUU7Z0RBQ0osTUFBTSxFQUFFLFFBQVE7Z0RBQ2hCLFNBQVMsRUFBRSw2RkFBNkY7NkNBQ3pHOzRDQUNELE1BQU0sRUFBRTtnREFDTixNQUFNLEVBQUUsUUFBUTtnREFDaEIsTUFBTSxFQUFFO29EQUNOLHlCQUF5QjtpREFDMUI7NkNBQ0Y7eUNBQ0Y7d0NBQ0QsVUFBVSxFQUFFOzRDQUNWLElBQUk7NENBQ0osTUFBTTt5Q0FDUDtxQ0FDRjtpQ0FDRjs2QkFDRjs0QkFDRCxVQUFVLEVBQUUsQ0FBQzs0QkFDYixVQUFVLEVBQUU7Z0NBQ1YsSUFBSTtnQ0FDSixNQUFNOzZCQUNQO3lCQUNGO3FCQUNGO29CQUNELFVBQVUsRUFBRTt3QkFDVixNQUFNO3FCQUNQO2lCQUNGO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1Ysb0JBQW9CO2FBQ3JCO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLElBQUk7UUFDSixlQUFlO1FBQ2YsTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9